import { PessoaTaxaModel } from 'model/api/gestao/pessoa-taxa/pessoa-taxa-model';
import { EnumInstituicao } from 'model/enums/enum-instituicao';

export class PessoaTaxaFormModel {
  constructor(
    public taxaVendaSoftwareHouse: PessoaTaxaModel | null = null,
    public taxaCustoRevenda: PessoaTaxaModel | null = null,
    public taxaVendaRevenda: PessoaTaxaModel | null = null,
    public taxaCustoCliente: PessoaTaxaModel | null = null,
    public credencialId: string = '',
    public tipoTransacao: number = 2,
    public instituicaoFinanceira: EnumInstituicao = EnumInstituicao.Safra,
  ) {}
}
